import { useState } from "react";
import { server } from "../../../config";
import ProductSmallTile from "../../../components/product-tile/product-small-tile";

export default function FrontProducts() {
	const [wominanizer, setWomanizer] = useState<any[] | null>(null);
	const [vibrator, setVibrator] = useState<any[] | null>(null);
	const [fifty, setFifty] = useState<any[] | null>(null);
	const [condoms, setCondoms] = useState<any[] | null>(null);
	const [handy, setHandy] = useState<any[] | null>(null);
	const [fetchedRandomProducts, setFetchedRandomProducts] = useState(false);

	if (!fetchedRandomProducts) {
		setFetchedRandomProducts(true);
		var funcs$ = [
		  fetch(`${server}/api/category/getRandom?category=Womanizer`),
		  fetch(`${server}/api/category/getRandom?category=Vibrator`),
		  fetch(`${server}/api/category/getRandom?category=Fifty`),
		  fetch(`${server}/api/category/getRandom?category=Kondomer`),
		  fetch(`${server}/api/category/getRandom?category=for`),
		]
		Promise.all(funcs$).then(async (response) => {
		  setFetchedRandomProducts(true);
		  setWomanizer(shuffleArray(await response[0].json()));
		  setVibrator(shuffleArray(await response[1].json()));
		  setFifty(shuffleArray(await response[2].json()));
		  setCondoms(shuffleArray(await response[3].json()));
		  setHandy(shuffleArray(await response[4].json()));
		}).catch((error) => {
		  setFetchedRandomProducts(true);
		});
	  }
	function shuffleArray(array: any[]) {
		for (var i = array.length - 1; i >= 0; i--) {
			var j = Math.floor(Math.random() * (i + 1));
			var temp = array[i];
			array[i] = array[j];
			array[j] = temp;
		}
		return array;
	}

	return (
		<>
			<br />
			<div className="showInMobile">

			</div>
			<h2>Utvalgte produkter</h2>
			<h3>For han og henne</h3>
			<section>
				{
					handy?.map && handy?.map(p =>
						<ProductSmallTile detailsPath='sexleketoy/produkter' product={p} size='normal' key={p._id} />
					)
				}
			</section>
			<h3>Vibrator</h3>
			<section>
				{
					vibrator?.map && vibrator?.map(p =>
						<ProductSmallTile detailsPath='sexleketoy/produkter' product={p} size='normal' key={p._id} />
					)
				}
			</section>
			<h3>Fifty Shades of Gray</h3>
			<section>
				{
					fifty?.map && fifty?.map(p =>
						<ProductSmallTile detailsPath='sexleketoy/produkter' product={p} size='normal' key={p._id} />
					)
				}
			</section>
			<div className="hideInMobile hideOnPad">
				<br />
				<a href="https://www.partner-ads.com/no/klikbanner.php?partnerid=30465&bannerid=110645" target="_blank" rel="nofollow noopener">
					<img src="https://www.partner-ads.com/no/visbanner.php?partnerid=30465&bannerid=110645" alt="Merlykke.no" /></a>
			</div>
			<h3>Kondomer</h3>
			<section>
				{
					condoms?.map && condoms?.map(p =>
						<ProductSmallTile detailsPath='sexleketoy/produkter' product={p} size='normal' key={p._id} />
					)
				}
			</section>
			<h3>Womanizer</h3>
			<section>
				{
					wominanizer?.map && wominanizer?.map(p =>
						<ProductSmallTile detailsPath='sexleketoy/produkter' product={p} size='normal' key={p._id} />
					)
				}
			</section>
		</>
	);
}